const routes = [
    {
        label: 'Network Home Page',
        path: '/:network?',
        component: 'home'
    },
    {
        label: 'Network Blocks Page',
        path: '/:network/blocks',
        component: 'blocks'
    },
    {
        label: 'Network Block Details Page',
        path: '/:network/block/:blockNumber',
        component: 'block'
    },
    {
        label: 'Network Block Countdown Page',
        path: '/:network/block/countdown/:blockNumber',
        component: 'block',
        subComponent: 'countdown.block'
    },
    {
        label: 'Network Transactions Page',
        path: '/:network/txs',
        component: 'transactions'
    },
    {
        label: 'Network Transactions Pending Page',
        path: '/:network/txsPending',
        component: 'pendingTransactions'
    },
    {
        label: 'Network Transaction Details Page',
        path: '/:network/tx/:transactionHash',
        component: 'transaction'
    },
    {
        label: 'Network Internal Transactions Page',
        path: '/:network/txsInternal',
        component: 'internalTransactions'
    },
    {
        label: 'Network Verified Contracts Page',
        path: '/:network/contractsVerified',
        component: 'contractsVerified'
    },
    {
        label: 'Network Address Details Page',
        path: '/:network/address/:address',
        component: 'address'
    },
    {
        label: 'Network Tokens Page',
        path: '/:network/tokens',
        component: 'tokens'
    },
    {
        label: 'Network Token Transfers Page',
        path: '/:network/tokentxns',
        component: 'tokenTransfers'
    },
    {
        label: 'Network Token Details Page',
        path: '/:network/token/:address',
        component: 'token'
    },
    {
        label: 'Network NFTs Page',
        path: '/:network/nft-top-contracts',
        component: 'nfts'
    },
    {
        label: 'Network NFT Transfers Page',
        path: '/:network/nft-transfers',
        component: 'nftTransfers'
    },
    {
        label: 'Network NFT Latest Mints Page',
        path: '/:network/nft-latest-mints',
        component: 'nftMints'
    },
    {
        label: 'Network NFT Page',
        path: '/:network/nft/:address/:tokenId',
        component: 'nft'
    },
    {
        label: 'Network Verify Contract Page',
        path: '/:network/verifyContract',
        component: 'verifyContract'
    },
    {
        label: 'Network Verify Contract Single File Page',
        path: '/:network/verifyContract-solc',
        component: 'verifyContract-solc'
    },
    {
        label: 'Network Verify Contract Multiple Files Page',
        path: '/:network/verifyContract-solc-multiple',
        component: 'verifyContract-solc-multiple'
    },
    {
        label: 'Network Verify Contract Json File Page',
        path: '/:network/verifyContract-solc-json',
        component: 'verifyContract-solc-json'
    },
    {
        label: 'Network Beacon Home Page',
        path: '/:network/beacon',
        component: 'beaconHome'
    },
    {
        label: 'Network Beacon Epochs Page',
        path: '/:network/epochs',
        component: 'epochs'
    },
    {
        label: 'Network Beacon Epoch Page',
        path: '/:network/epoch/:epoch',
        component: 'epoch'
    },
    {
        label: 'Network Beacon Slots Page',
        path: '/:network/slots',
        component: 'slots'
    },
    {
        label: 'Network Beacon Slot Page',
        path: '/:network/slot/:slot',
        component: 'slot'
    },
    {
        label: 'Network Beacon Validators Page',
        path: '/:network/validators',
        component: 'validators'
    },
    {
        label: 'Network Find Similar Contract Page',
        path: '/:network/find-similar-contracts',
        component: 'similarContracts'
    }
]

module.exports = {
    routes
}
